import { MultiLangString } from './lingua_sistema';

import { Gravidanza } from './gravidanza';
import { SchemaPrestazione, Prestazione, Prescrizione } from './prestazione';
import { Rimando } from './rimando';
import { AreaVasta } from './anagrafica_geo';

export abstract class FiltroPeridodoGravidanza extends Rimando {
    postparto: boolean = false;
    giorno_inizio: number = 0;
    giorno_fine: number = 0;
    begin_week:number = 0;
    begin_day:number = 0;
    end_week:number = 0;
    end_day:number = 0;

    get settimana_inizio(): number {
        return Math.floor(this.giorno_inizio / 7);
    }

    set settimana_inizio(sett) {
        if (isFinite(sett)){
            this.begin_week=sett;
            this.giorno_inizio = this.begin_week * 7 + this.begin_day;    
        }
    }

    get giorno_settimana_inizio(): number {
        return this.giorno_inizio % 7;
    }
    set giorno_settimana_inizio(giorno_sett) {
        if (isFinite(giorno_sett)){
            this.begin_day=giorno_sett % 7;
            this.giorno_inizio = this.begin_week * 7 + this.begin_day;    
        }
        //this.giorno_inizio = (this.settimana_inizio * 7) + parseInt(''+giorno_sett);
    }

    get settimana_fine(): number {
        return Math.floor(this.giorno_fine / 7);
    }
    set settimana_fine(sett) {
        if (isFinite(sett)){
            this.end_week=sett;
            this.giorno_fine = this.end_week * 7 + this.end_day;    
        }
        //this.giorno_fine = (sett * 7) + this.giorno_settimana_fine;
        //console.log("fine, set sett ", sett, this.giorno_fine, this.settimana_fine, this.giorno_fine);
    }

    get giorno_settimana_fine(): number {
        return this.giorno_fine % 7;
    }
    set giorno_settimana_fine(giorno_sett) {
        if (isFinite(giorno_sett)){
            this.end_day=giorno_sett % 7;
            this.giorno_fine = this.end_week * 7 + this.end_day;    
        }
        //this.giorno_fine = (this.settimana_fine * 7) + parseInt(''+giorno_sett);
        //console.log("fine, set giorno ", giorno_sett, this.giorno_fine, this.settimana_fine, this.giorno_fine);
    }
}

export abstract class FiltroLatePeridodoGravidanza extends FiltroPeridodoGravidanza {
    giorno_fine_lateinstall: number;
}

export class SchemaAgenda extends FiltroLatePeridodoGravidanza {
    static readonly rest_path = 'schemi_agenda';

    id: number;
    nome: MultiLangString;
    label: string;
    postparto: boolean;
    no_gemellare: boolean;
    giorno_inizio: number;
    giorno_fine: number;
    giorno_fine_lateinstall: number;
    da_prenotare: boolean;
    prenotabile_app: boolean;
    da_protocollo: boolean;
    disabled: boolean;
    protocollo_ordinamento: number;
    schemi_prestazione: SchemaPrestazione[];
    //prestazioni: Prestazione[];
    area_vasta: number; //AreaVasta
    opzionale: boolean;
    note: string;
    rimando: string;
}

export class AgendaUtente {
    id: number;
    nome: string;
    giorno_inizio: number; // data
    giorno_fine: number; // data
    appuntamento_inizio: Date; // data
    appuntamento_fine: Date; // data
    ordinamento_inizio: Date; // data e ora
    ordinamento_fine: Date; // data e ora
    prenotato: boolean;
    eseguito: boolean;
    Schema_agenda: SchemaAgenda;
    da_protocollo: boolean;
    gravidanza: number | Gravidanza;
    id_prenotazione: string;
    tipo_prenotazione: string; // enum
    prenotazione_codice_struttura: string;
    prenotazione_nome_struttura: string;
    prenotazione_note: string;
    prenotazione_luogo_struttura: string;
    prestazioni: Prestazione[];
    prescrizioni: Prescrizione[];
}
